import styled, { css } from 'styled-components';

import {
    Button,
    Card,
    mediaMixin,
} from '@zillow/constellation';

import {
    Row,
} from '@zillow/zrs-comet';

export const StyledHeadingLink = styled.span`
    ${mediaMixin('sm', css`
        float: right;
    `)}

`;

export const StyledSpinnerCard = styled(Card)`
    height: 316px;
`;

export const StyledButton = styled(Button)`
    float: right;
    width: 100%;

    ${mediaMixin('lg', css`
        width: auto;
    `)}
`;

export const StyledRowApplicationCardsContainer = styled(Row)`
    min-height: 320px;
`;

export const StyledContainer = styled.div`
    margin-top: 8px;

    ${mediaMixin('md', css`
        margin-top: 0px;
    `)}
`;
